export const bulletinsData = [
    {
        "id": "circular",
        "name": "Circulars",
        "items": [
            {
                "title": "Circular No. 26/2026-Customs dated: 15.05.2026",
                "number": "Circular No. 26/2026-Customs",
                "date": "15/05/2026",
                "link": "https://asrm.co.in/detail/59549.aspx"
            },
            {
                "title": "Circular No. 25/2026-Customs dated: 14.05.2026",
                "number": "Circular No. 25/2026-Customs",
                "date": "14/05/2026",
                "link": "https://asrm.co.in/detail/59270.aspx"
            },
            {
                "title": "Circular No. 24/2026-Customs dated: 14.05.2026",
                "number": "Circular No. 24/2026-Customs",
                "date": "14/05/2026",
                "link": "https://asrm.co.in/detail/59269.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/notificationsearch/Bulletins/Circular/BullNotification/Circular.aspx"
    },
    {
        "id": "notification",
        "name": "Notifications",
        "items": [
            {
                "title": "The Companies (Registered Valuers and Valuation) Amendment Rules, 2026",
                "number": "Notification",
                "date": "05/06/2026",
                "link": "https://asrm.co.in/detail/59766.aspx"
            },
            {
                "title": "Formation of new district in the State of Assam – Assignment of Lead Bank Responsibility..",
                "number": "RBI/2026-27/96",
                "date": "03/06/2026",
                "link": "https://asrm.co.in/detail/59760.aspx"
            },
            {
                "title": "Notification No. 70/2026 [F. No. 500/Misc./S10(23FE)/FT&TR-II] / SO 2768(E)",
                "number": "Notification No. 70/2026",
                "date": "01/06/2026",
                "link": "https://asrm.co.in/detail/59765.aspx"
            },
            {
                "title": "Notification No. 69/2026-CBDT[F. No. 203/18/2025/ITA-II] / SO 2752(E)",
                "number": "Notification No. 69/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59764.aspx"
            },
            {
                "title": "Notification No. 68/2026-CBDT[F. No. 203/17/2025/ITA-II] / SO 2751(E)",
                "number": "Notification No. 68/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59763.aspx"
            },
            {
                "title": "Notification No. 67/2026-CBDT[F. No. 203/16/2025/ITA-II] / SO 2750(E)",
                "number": "Notification No. 67/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59762.aspx"
            },
            {
                "title": "Notification No. 66/2026-CBDT[F. No. 203/15/2025/ITA-II] / SO 2749(E)",
                "number": "Notification No. 66/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59761.aspx"
            },
            {
                "title": "G.S.R. 415(E). - In exercise of the powers conferred by section 135 and sub-sections (1) and (2)",
                "number": "Notification",
                "date": "28/05/2026",
                "link": "https://asrm.co.in/detail/59749.aspx"
            },
            {
                "title": "G.S.R. 416(E). In exercise of the powers conferred by sub-section (1) of section 467 of the Companie",
                "number": "Notification",
                "date": "28/05/2026",
                "link": "https://asrm.co.in/detail/59748.aspx"
            },
            {
                "title": "Reserve Bank of India (Rural Co-operative Banks - Governance) Amendment Directions, 2026",
                "number": "RBI/DOR/2026-27/95",
                "date": "25/05/2026",
                "link": "https://asrm.co.in/detail/59732.aspx"
            },
            {
                "title": "Reserve Bank of India (Urban Co-operative Banks - Governance) Amendment Directions, 2026",
                "number": "RBI/DOR/2026-27/94",
                "date": "25/05/2026",
                "link": "https://asrm.co.in/detail/59731.aspx"
            },
            {
                "title": "Implementation of Section 51A of UAPA, 1967: Updates to UNSC’s 1267/ 1989 ISIL (Da'esh) May 22, 2026",
                "number": "RBI/2026-27/93",
                "date": "22/05/2026",
                "link": "https://asrm.co.in/detail/59729.aspx"
            },
            {
                "title": "Notification No. 47/2026-CUSTOMS (N.T.) dated: 19.05.2026",
                "number": "Notification No. 47/2026-CUSTOMS (N.T.)",
                "date": "19/05/2026",
                "link": "https://asrm.co.in/detail/59551.aspx"
            },
            {
                "title": "Reserve Bank of India (Local Area Banks – Financial Statements: Presentation and Disclosures) Third",
                "number": "RBI/2026-27/92",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59727.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks – Financial Statements: Presentation and Disclosures) Sixth",
                "number": "RBI/2026-27/91",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59725.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks – Prudential Norms on Capital Adequacy) Sixth Amendment Dire",
                "number": "RBI/2026-27/90",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59724.aspx"
            },
            {
                "title": "Reserve Bank of India (Regional Rural Banks - Classification, Valuation, and Operation of Investment",
                "number": "RBI/2026-27/89",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59723.aspx"
            },
            {
                "title": "Reserve Bank of India (Rural Co-operative Banks – Classification, Valuation, and Operation of Invest",
                "number": "RBI/2026-27/88",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59722.aspx"
            },
            {
                "title": "Reserve Bank of India (Urban Co-operative Banks – Classification, Valuation, and Operation of Invest",
                "number": "RBI/2026-27/87",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59721.aspx"
            },
            {
                "title": "Reserve Bank of India (Local Area Banks - Classification, Valuation, and Operation of Investment Por",
                "number": "RBI/2026-27/86",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59720.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/notificationsearch/Bulletins/Notification/BullNotification/Notification.aspx"
    },
    {
        "id": "service-tax-bulletin",
        "name": "Service Tax",
        "items": [
            {
                "title": "Recent Notification / Circular on Service Tax",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Service_Tax/Service_Tax.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Service_Tax/Service_Tax.aspx"
    },
    {
        "id": "rbi-sebi",
        "name": "RBI & SEBI",
        "items": [
            {
                "title": "Formation of new district in the State of Assam – Assignment of Lead Bank Responsibility..",
                "number": "RBI/2026-27/96",
                "date": "03/06/2026",
                "link": "https://asrm.co.in/detail/59760.aspx"
            },
            {
                "title": "Reserve Bank of India (Rural Co-operative Banks - Governance) Amendment Directions, 2026",
                "number": "RBI/DOR/2026-27/95",
                "date": "25/05/2026",
                "link": "https://asrm.co.in/detail/59732.aspx"
            },
            {
                "title": "Reserve Bank of India (Urban Co-operative Banks - Governance) Amendment Directions, 2026",
                "number": "RBI/DOR/2026-27/94",
                "date": "25/05/2026",
                "link": "https://asrm.co.in/detail/59731.aspx"
            },
            {
                "title": "Implementation of Section 51A of UAPA, 1967: Updates to UNSC’s 1267/ 1989 ISIL (Da'esh) May 22, 2026",
                "number": "RBI/2026-27/93",
                "date": "22/05/2026",
                "link": "https://asrm.co.in/detail/59729.aspx"
            },
            {
                "title": "Reserve Bank of India (Local Area Banks – Financial Statements: Presentation and Disclosures) Third",
                "number": "RBI/2026-27/92",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59727.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks – Financial Statements: Presentation and Disclosures) Sixth",
                "number": "RBI/2026-27/91",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59725.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks – Prudential Norms on Capital Adequacy) Sixth Amendment Dire",
                "number": "RBI/2026-27/90",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59724.aspx"
            },
            {
                "title": "Reserve Bank of India (Regional Rural Banks - Classification, Valuation, and Operation of Investment",
                "number": "RBI/2026-27/89",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59723.aspx"
            },
            {
                "title": "Reserve Bank of India (Rural Co-operative Banks – Classification, Valuation, and Operation of Invest",
                "number": "RBI/2026-27/88",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59722.aspx"
            },
            {
                "title": "Reserve Bank of India (Urban Co-operative Banks – Classification, Valuation, and Operation of Invest",
                "number": "RBI/2026-27/87",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59721.aspx"
            },
            {
                "title": "Reserve Bank of India (Local Area Banks - Classification, Valuation, and Operation of Investment Por",
                "number": "RBI/2026-27/86",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59720.aspx"
            },
            {
                "title": "Reserve Bank of India (Payments Banks - Classification, Valuation, and Operation of Investment Portf",
                "number": "RBI/2026-27/85",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59719.aspx"
            },
            {
                "title": "Reserve Bank of India (Small Finance Banks - Classification, Valuation, and Operation of Investment",
                "number": "RBI/2026-27/84",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59718.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks - Classification, Valuation, and Operation of Investment Por",
                "number": "RBI/2026-27/83",
                "date": "18/05/2026",
                "link": "https://asrm.co.in/detail/59717.aspx"
            },
            {
                "title": "Operating framework for facilitating Outward Remittance services by non-bank entities through Author",
                "number": "RBI/2026-27/82",
                "date": "13/05/2026",
                "link": "https://asrm.co.in/detail/59184.aspx"
            },
            {
                "title": "Reserve Bank of India (Payments Banks - Prudential Norms on Capital Adequacy) Second Amendment Direc",
                "number": "RBI/2026-27/81",
                "date": "08/05/2026",
                "link": "https://asrm.co.in/detail/59141.aspx"
            },
            {
                "title": "Reserve Bank of India (Small Finance Banks - Prudential Norms on Capital Adequacy) Fourth Amendment",
                "number": "RBI/2026-27/80",
                "date": "08/05/2026",
                "link": "https://asrm.co.in/detail/59140.aspx"
            },
            {
                "title": "Reserve Bank of India (Commercial Banks - Prudential Norms on Capital Adequacy) Fifth Amendment Dire",
                "number": "RBI/2026-27/79",
                "date": "08/05/2026",
                "link": "https://asrm.co.in/detail/59139.aspx"
            },
            {
                "title": "Issuance of Foreign Exchange Management (Authorised Persons) Regulations, 2026..",
                "number": "RBI/2026-27/78",
                "date": "06/05/2026",
                "link": "https://asrm.co.in/detail/59138.aspx"
            },
            {
                "title": "Foreign Exchange Management (Authorised Persons) Regulations, 2026",
                "number": "Notification No. FEMA 401/2026-RB",
                "date": "06/05/2026",
                "link": "https://asrm.co.in/detail/59137.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/RBISEBI/RBISEBI.aspx"
    },
    {
        "id": "income-tax-bulletin",
        "name": "Income Tax",
        "items": [
            {
                "title": "Notification No. 70/2026 [F. No. 500/Misc./S10(23FE)/FT&TR-II] / SO 2768(E)",
                "number": "Notification No. 70/2026",
                "date": "01/06/2026",
                "link": "https://asrm.co.in/detail/59765.aspx"
            },
            {
                "title": "Notification No. 69/2026-CBDT[F. No. 203/18/2025/ITA-II] / SO 2752(E)",
                "number": "Notification No. 69/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59764.aspx"
            },
            {
                "title": "Notification No. 68/2026-CBDT[F. No. 203/17/2025/ITA-II] / SO 2751(E)",
                "number": "Notification No. 68/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59763.aspx"
            },
            {
                "title": "Notification No. 67/2026-CBDT[F. No. 203/16/2025/ITA-II] / SO 2750(E)",
                "number": "Notification No. 67/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59762.aspx"
            },
            {
                "title": "Notification No. 66/2026-CBDT[F. No. 203/15/2025/ITA-II] / SO 2749(E)",
                "number": "Notification No. 66/2026",
                "date": "30/05/2026",
                "link": "https://asrm.co.in/detail/59761.aspx"
            },
            {
                "title": "Notification No. 6/2026: Order under clause (iia) of sub-section (1) of section 35 of the Income Tax",
                "number": "Notification No. 6/2026",
                "date": "12/05/2026",
                "link": "https://asrm.co.in/detail/59279.aspx"
            },
            {
                "title": "Notification No. 64/2026 [F. No. 370142/41/2025-TPL] / GSR 286(E) : Corrigendum",
                "number": "Notification No. 64/2026",
                "date": "16/04/2026",
                "link": "https://asrm.co.in/detail/58898.aspx"
            },
            {
                "title": "Notification No. 63/2026 [F. No. 370142/13/2026-TPL]/ GSR 268(E) : Corrigendum to Notification of In",
                "number": "Notification No. 63/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58846.aspx"
            },
            {
                "title": "Notification No. 62/2026 [F. No. 370142/10/2026-TPL]/ GSR 267(E) : Corrigendum to Notification of In",
                "number": "Notification No. 62/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58837.aspx"
            },
            {
                "title": "Notification No. 61/2026 [F. No. 370142/9/2026-TPL] / GSR 266(E) : Corrigendum to Notification of In",
                "number": "Notification No. 61/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58836.aspx"
            },
            {
                "title": "Notification No. 60/2026 [F. No. 370142/8/2026-TPL]/ GSR 265(E) : Corrigendum to Notification of Inc",
                "number": "Notification No. 60/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58835.aspx"
            },
            {
                "title": "Notification No. 59/2026 [F. No. 370142/7/2026-TPL] / GSR 264(E) : Corrigendum to Notification of In",
                "number": "Notification No. 59/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58834.aspx"
            },
            {
                "title": "Notification No. 58/2026 [F. No. 370142/6/2026-TPL] / GSR 263(E) : Corrigendum to Notification of In",
                "number": "Notification No. 58/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58833.aspx"
            },
            {
                "title": "Notification No. 57/2026 [F. No. 370142/5/2026-TPL] / GSR 262(E) : Corrigendum to Notification of In",
                "number": "Notification No. 57/2026",
                "date": "10/04/2026",
                "link": "https://asrm.co.in/detail/58832.aspx"
            },
            {
                "title": "Notification No. 56/2026 [F. No. 500/22/2022-FT&TR-V] / S.O. 1715(E)",
                "number": "Notification No. 56/2026",
                "date": "02/04/2026",
                "link": "https://asrm.co.in/detail/58643.aspx"
            },
            {
                "title": "F. No. ADG(S)-1/PAN/M/3699/2026-AD-DD SYSTEMS 1-5 DELHI : Order for specifying Forms and procedures",
                "number": "F. No. ADG(S)-1/PAN/M/3699/2026-",
                "date": "01/04/2026",
                "link": "https://asrm.co.in/detail/58591.aspx"
            },
            {
                "title": "Notification No. 55/2026 [F. No. 370142/15/2026-TPL] / G.S.R. 241(E) : Income-tax (Amendment) Rules,",
                "number": "Notification No. 55/2026",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/detail/58590.aspx"
            },
            {
                "title": "Notification No. 54/2026 [F. No. 370142/15/2026-TPL] / G.S.R. 240(E)- Income-tax (Tenth Amendment) R",
                "number": "Notification No. 54/2026",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/detail/58589.aspx"
            },
            {
                "title": "Notification No. 53/2026 [F.No.300195/48/2025-ITA-I] / SO 1664(E)",
                "number": "Notification No. 53/2026",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/detail/58588.aspx"
            },
            {
                "title": "Notification No. 52/2026 [F.No. 370142/13/2026-TPL] / G.S.R. 233(E)",
                "number": "Notification No. 52/2026",
                "date": "30/03/2026",
                "link": "https://asrm.co.in/detail/58587.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Income_Tax/Income_Tax.aspx"
    },
    {
        "id": "central-sales-tax-bulletin",
        "name": "Central Sales Tax",
        "items": [
            {
                "title": "Recent Notification / Circular on Central Sales Tax",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Central_Sales_Tax/Central_Sales_Tax.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Central_Sales_Tax/Central_Sales_Tax.aspx"
    },
    {
        "id": "customs-bulletin",
        "name": "Customs",
        "items": [
            {
                "title": "Notification No. 47/2026-CUSTOMS (N.T.) dated: 19.05.2026",
                "number": "Notification No. 47/2026-CUSTOMS (N.T.)",
                "date": "19/05/2026",
                "link": "https://asrm.co.in/detail/59551.aspx"
            },
            {
                "title": "Notification No. 45/2026-CUSTOMS (N.T.) dated: 08.05.2026",
                "number": "Notification No. 45/2026-CUSTOMS (N.T.)",
                "date": "08/05/2026",
                "link": "https://asrm.co.in/detail/59068.aspx"
            },
            {
                "title": "Notification No. 43/2026-CUSTOMS (N.T.) dated: 06.05.2026",
                "number": "Notification No. 43/2026-CUSTOMS (N.T.)",
                "date": "06/05/2026",
                "link": "https://asrm.co.in/detail/59013.aspx"
            },
            {
                "title": "Notification No. 42/2026-CUSTOMS (N.T.) dated: 30.04.2026",
                "number": "Notification No. 42/2026-CUSTOMS (N.T.)",
                "date": "30/04/2026",
                "link": "https://asrm.co.in/detail/59012.aspx"
            },
            {
                "title": "Notification No. 41/2026-- Customs (N.T.) dated: 24.04.2026",
                "number": "Notification No. 41/2026-- Customs (N.T.)",
                "date": "24/04/2026",
                "link": "https://asrm.co.in/detail/59011.aspx"
            },
            {
                "title": "Notification No. 40/2026-Customs (N.T.) dated: 23.04.2026",
                "number": "Notification No. 40/2026-Customs (N.T.)",
                "date": "23/04/2026",
                "link": "https://asrm.co.in/detail/59010.aspx"
            },
            {
                "title": "Notification No. 39/2026-Customs (N.T.) dated: 20.04.2026",
                "number": "Notification No. 39/2026-Customs (N.T.)",
                "date": "20/04/2026",
                "link": "https://asrm.co.in/detail/59009.aspx"
            },
            {
                "title": "Notification No. 38/2026-Customs (N.T.) dated: 16.04.2026",
                "number": "Notification No. 38/2026-Customs (N.T.)",
                "date": "16/04/2026",
                "link": "https://asrm.co.in/detail/59008.aspx"
            },
            {
                "title": "Notification No. 37/2026-CUSTOMS (N.T.) dated: 15.04.2026",
                "number": "Notification No. 37/2026-CUSTOMS (N.T.)",
                "date": "15/04/2026",
                "link": "https://asrm.co.in/detail/58884.aspx"
            },
            {
                "title": "NOTIFICATION No. 36/2026 - Customs (N.T.) dated: 06.04.2026",
                "number": "NOTIFICATION No. 36/2026 - Customs (N.T.)",
                "date": "06/04/2026",
                "link": "https://asrm.co.in/detail/58883.aspx"
            },
            {
                "title": "Notification No. 35/2026-CUSTOMS (N.T.) dated: 02.04.2026",
                "number": "Notification No. 35/2026-CUSTOMS (N.T.)",
                "date": "02/04/2026",
                "link": "https://asrm.co.in/detail/58818.aspx"
            },
            {
                "title": "Notification No. 34/2026-Customs (N.T.) dated: 31.03.2026",
                "number": "Notification No. 34/2026-Customs (N.T.)",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/detail/58817.aspx"
            },
            {
                "title": "Notification No. 33/2026-Customs (N.T.) dated: 31.03.2026",
                "number": "Notification No. 33/2026-Customs (N.T.)",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/notificationdetail.aspx?acturl=WApIh9eSlBwkY+3iMrGpNKRk9xnA8j1ZKrSOD6q++fdqBwC2aNteJjtAcVBOtVmE"
            },
            {
                "title": "Notification No. 32/2026-CUSTOMS (N.T.) dated: 30.03.2026",
                "number": "Notification No. 32/2026-CUSTOMS (N.T.)",
                "date": "30/03/2026",
                "link": "https://asrm.co.in/detail/58813.aspx"
            },
            {
                "title": "Notification No. 31/2026-Customs (N.T.) dated: 30.03.2026",
                "number": "Notification No. 31/2026-Customs (N.T.) dated: 30.03.2026",
                "date": "30/03/2026",
                "link": "https://asrm.co.in/detail/58806.aspx"
            },
            {
                "title": "Notification No. 30/2026-Customs (N.T.) dated: 24.03.2026",
                "number": "Notification No. 30/2026-Customs (N.T.)",
                "date": "24/03/2026",
                "link": "https://asrm.co.in/notificationdetail.aspx?acturl=WApIh9eSlBwkY+3iMrGpNKRk9xnA8j1ZKrSOD6q++fde1eAvet9MUGCdfiAaMdtQ"
            },
            {
                "title": "Notification No. 29/2026-Customs (N.T.) dated: 20.03.2026",
                "number": "Notification No. 29/2026-Customs (N.T.)",
                "date": "20/03/2026",
                "link": "https://asrm.co.in/notificationdetail.aspx?acturl=WApIh9eSlBwkY+3iMrGpNKRk9xnA8j1ZKrSOD6q++fdAkTx5qHRbxq0O2nalZHG+"
            },
            {
                "title": "Notification No. 28/2026-CUSTOMS (N.T.) dated: 20.03.2026",
                "number": "Notification No. 28/2026-CUSTOMS (N.T.)",
                "date": "20/03/2026",
                "link": "https://asrm.co.in/detail/58252.aspx"
            },
            {
                "title": "Notification No. 27/2026-CUSTOMS (N.T.) dated: 19.03.2026",
                "number": "Notification No. 27/2026-CUSTOMS (N.T.)",
                "date": "19/03/2026",
                "link": "https://asrm.co.in/detail/58251.aspx"
            },
            {
                "title": "Notification No. 26/2026-CUSTOMS (N.T.) dated: 16.03.2026",
                "number": "Notification No. 26/2026-CUSTOMS (N.T.)",
                "date": "16/03/2026",
                "link": "https://asrm.co.in/notificationdetail.aspx?acturl=WApIh9eSlBwkY+3iMrGpNKRk9xnA8j1ZKrSOD6q++ffIgVxcj2z0sV51ab7VKnWL"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Customs/Customs.aspx"
    },
    {
        "id": "corporate-matters",
        "name": "Corporate Matters",
        "items": [
            {
                "title": "The Companies (Registered Valuers and Valuation) Amendment Rules, 2026",
                "number": "Notification",
                "date": "05/06/2026",
                "link": "https://asrm.co.in/detail/59766.aspx"
            },
            {
                "title": "G.S.R. 415(E). - In exercise of the powers conferred by section 135 and sub-sections (1) and (2)",
                "number": "Notification",
                "date": "28/05/2026",
                "link": "https://asrm.co.in/detail/59749.aspx"
            },
            {
                "title": "G.S.R. 416(E). In exercise of the powers conferred by sub-section (1) of section 467 of the Companie",
                "number": "Notification",
                "date": "28/05/2026",
                "link": "https://asrm.co.in/detail/59748.aspx"
            },
            {
                "title": "The Companies (Registration Offices and Fees) Amendment Rules, 2026",
                "number": "Notification",
                "date": "21/04/2026",
                "link": "https://asrm.co.in/detail/59067.aspx"
            },
            {
                "title": "Important MCA Update for Directors on New DIR-3 KYC Web form",
                "number": "Important MCA Update for Directors on New DIR-3 KYC Web form",
                "date": "31/03/2026",
                "link": "https://asrm.co.in/detail/59065.aspx"
            },
            {
                "title": "Companies (Accounting Standards) Amendment Rules 2026",
                "number": "Notification",
                "date": "12/03/2026",
                "link": "https://asrm.co.in/detail/58185.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Corporate_Matters/Corporate_Matters.aspx"
    },
    {
        "id": "labour-laws-bulletin",
        "name": "Labour Laws",
        "items": [
            {
                "title": "Recent Notification / Circular on Labour Laws",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Labour_Laws/Labour_Laws.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Labour_Laws/Labour_Laws.aspx"
    },
    {
        "id": "excise-matters",
        "name": "Excise Matters",
        "items": [
            {
                "title": "Notification No. 02/2026-Central Excise (N.T.) dated: 26.03.2026",
                "number": "Notification No. 02/2026-Central Excise (N.T.)",
                "date": "26/03/2026",
                "link": "https://asrm.co.in/detail/59152.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Excise_Matters/Excise_Matters.aspx"
    },
    {
        "id": "fema-bulletin",
        "name": "FEMA",
        "items": [
            {
                "title": "Recent Notification / Circular on FEMA",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/F_E_M_A/F_E_M_A.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/F_E_M_A/F_E_M_A.aspx"
    },
    {
        "id": "news-llp",
        "name": "News on LLP",
        "items": [
            {
                "title": "Recent Notification / Circular on News on LLP",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/News_on_LLP/News_on_LLP.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/News_on_LLP/News_on_LLP.aspx"
    },
    {
        "id": "other-bulletin",
        "name": "Other Bulletins",
        "items": [
            {
                "title": "Recent Notification / Circular on Other Bulletins",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Other/Other.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Other/Other.aspx"
    },
    {
        "id": "accounting-standards-indas",
        "name": "Accounting Standards & IND AS",
        "items": [
            {
                "title": "Recent Notification / Circular on Accounting Standards & IND AS",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Accounting_Standards_INDAS/Accounting_Standards_INDAS.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Accounting_Standards_INDAS/Accounting_Standards_INDAS.aspx"
    },
    {
        "id": "gst-bulletin",
        "name": "GST",
        "items": [
            {
                "title": "Notification No. 01/2026-Central Tax (Rate) dated: 30.04.2026",
                "number": "Notification No. 01/2026-Central Tax (Rate)",
                "date": "30/04/2026",
                "link": "https://asrm.co.in/detail/59005.aspx"
            },
            {
                "title": "NOTIFICATION No. 01 /2026 Central Tax dated: 21.04.2026",
                "number": "NOTIFICATION No. 01 /2026 Central Tax",
                "date": "21/04/2026",
                "link": "https://asrm.co.in/detail/59004.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/GST/GST.aspx"
    },
    {
        "id": "igst-bulletin",
        "name": "IGST",
        "items": [
            {
                "title": "Notification No. 01/2026-Integrated Tax (Rate) dated: 30.04.2026",
                "number": "Notification No. 01/2026-Integrated Tax (Rate)",
                "date": "30/04/2026",
                "link": "https://asrm.co.in/detail/59006.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/IGST/.aspx"
    },
    {
        "id": "utgst-bulletin",
        "name": "UTGST",
        "items": [
            {
                "title": "Notification No. 01/2026-Union Territory Tax (Rate) dated: 30.04.2026",
                "number": "Notification No. 01/2026-Union Territory Tax (Rate)",
                "date": "30/04/2026",
                "link": "https://asrm.co.in/detail/59007.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/UTGST/.aspx"
    },
    {
        "id": "ibc-regulation-bulletin",
        "name": "IBC Regulation",
        "items": [
            {
                "title": "Recent Notification / Circular on IBC Regulation",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/IBC_Regulation/.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/IBC_Regulation/.aspx"
    },
    {
        "id": "compensation-cess-bulletin",
        "name": "Compensation Cess",
        "items": [
            {
                "title": "Recent Notification / Circular on Compensation Cess",
                "number": "Circular / Notification",
                "date": "Current",
                "link": "https://asrm.co.in/resources/Bulletins/Compensation_Cess/.aspx"
            }
        ],
        "originalUrl": "https://asrm.co.in/resources/Bulletins/Compensation_Cess/.aspx"
    }
];


